import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  mainLineViewSkeleton: {
    display: 'flex',
    flexDirection: 'column',
    width: '800px',
    gap: '24px',
  },
});
